/**
 * @generated SignedSource<<2d6a0bbb04b731ce40bd74159381f15c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type job_useMismatchingSkillsUser$data = {
  readonly userSkills: ReadonlyArray<{
    readonly experience: number | null | undefined;
    readonly skill: {
      readonly id: string;
    } | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "job_useMismatchingSkillsUser";
};
export type job_useMismatchingSkillsUser$key = {
  readonly " $data"?: job_useMismatchingSkillsUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"job_useMismatchingSkillsUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "job_useMismatchingSkillsUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSkill",
      "kind": "LinkedField",
      "name": "userSkills",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "experience",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Skill",
          "kind": "LinkedField",
          "name": "skill",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4a9ef3bb7ff3ffc848f04abd53b82b22";

export default node;
